import { compose } from 'redux';
import { connect, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect } from 'react';
import styles from './styles.js';

// components
import ListingForm from 'now-frontend-shared/components/ListingForm';

// layouts
import HeadSection from 'now-frontend-shared/layouts/AuthSections/HeadSection';

// store
import {
  clearAWSData,
  createDraftListing,
  createProperty,
  getBasins,
  getCounties,
  getLandingZones,
  getPreSignedUrls,
  getStates,
  removeAWSDataFile,
  setAWSData,
  setBasinId,
  setStateId,
  setUnloadedFilesExist,
} from 'store/actions/createPropertyActions';
import { refreshTokens } from 'utils/apiMethods';
import Header from 'components/Header';
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

const formName = 'createListing';

const CreateProperty = props => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getStates());
  }, [dispatch]);

  const onSubmit = useCallback(
    formData => {
      const { isDraft } = formData;
      if (isDraft) {
        dispatch(createDraftListing({ formName, ...formData }));
      } else {
        dispatch(createProperty({ formName, ...formData }));
      }
    },
    [dispatch],
  );

  return (
    <>
      <Header />
      <Grid container className={props.classes.wrapper}>
        <ListingForm
          formName={formName}
          isForCreate
          onSubmit={onSubmit}
          keepSessionAlive={refreshTokens}
          {...props}
        >
          <HeadSection heading="Create a Listing" path="/my-listings" />
        </ListingForm>
      </Grid>
    </>
  );
};

CreateProperty.propTypes = {
  isDraft: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ createProperty, auth }) => ({
  AWSData: createProperty.AWSData,
  basins: createProperty.basins,
  clearAWSData,
  counties: createProperty.counties,
  getLandingZones,
  getBasins,
  getCounties,
  getPreSignedUrls,
  landingZones: createProperty.landingZones,
  preSignedUrls: createProperty.preSignedUrls,
  removeAWSDataFile,
  setAWSData,
  setBasinId,
  setStateId,
  setUnloadedFilesExist,
  states: createProperty.states,
  unloadedFilesExist: createProperty.unloadedFilesExist,
  listingOwner: auth.user,
  isDraft: createProperty.isForDraftSubmission,
});

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
)(CreateProperty);
